import { Component, ViewEncapsulation, input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { CdkMonitorFocus } from '@angular/cdk/a11y';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    host: {
      '[style.width]': 'flex() ? "100%" : "auto"'
    },
    imports: [CdkMonitorFocus, NgTemplateOutlet]
})
export class ButtonComponent {
  label = input('Button');
  disabled = input(false);
  /** variant: 'primary' | 'black' | 'ghost' */
  variant = input<string | undefined>(undefined);
  /** size: 'xs' | 'sm' | 'input-sm' | 'input-inline' | 'md' | 'lg' | 'icon' */
  size = input<string | undefined>(undefined);
  active = input(false);
  flex = input(false);
  iconButtonType = input<'success' | 'error' | 'warning' | 'info' | undefined>(undefined);
  ghostType = input<'success' | 'error' | undefined>(undefined);
}
